import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectorService } from '../../role-redirector/redirector.service';
import { UserInterface } from '../models/user.model';
import { UserService } from '../services/user/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  private redirectorService = inject(RedirectorService);
  private router = inject(Router);
  private userService = inject(UserService);

  ngOnInit() {
    this.userService.fromStorage().subscribe((user: UserInterface) => {
      this.redirectorService.resolveRouteParams(user.role.name).subscribe((url: any[]) => {
        this.router.navigate(url);
      });
    });
  }
}
